// extracted by mini-css-extract-plugin
module.exports = {"MainWrapper":"BlogList-module--MainWrapper--30ydY","RecentPostWrap":"BlogList-module--RecentPostWrap--3ar5m"};